<button matIconButton type="button" class="close" (click)="close()" matTooltipPosition="above"><mat-icon>close</mat-icon></button>

<h4>{{ 'send-remark.title' | translate }}</h4>

@if (browserSniffer.isTouchDevice) {
  <div>
    <!-- {{toolTip|json}} -->
    @if (toolTip.placeMarkerTouch) {
      <div>
        <p>
          {{'send-remark.about_map.help.content.touch.1'|translate}}
          <span class="marker"></span>
          <!-- <mat-icon aria-label="map">location_on</mat-icon> -->
          {{'send-remark.about_map.help.content.touch.2'|translate}}
        </p>
        <div class="button-container">
          <button mat-flat-button color="primary" (click)="lockPointTouch()">
            <mat-icon aria-label="map">lock</mat-icon>&nbsp;&nbsp;{{"send-remark.button.placemarker"|translate}}...
          </button>
        </div>
        <div class=""> 
          &nbsp;
          <!-- <a  (click)="close()" class="close-tip">&nbsp;{{"general.close"|translate}}</a> -->
        </div>
      </div>
    }
    <!-- 2 lock touch   -->
    @if (toolTip.lockMarkerTouch) {
      <div>
        <p>
          <mat-icon inline="true" aria-label="map" [color]="'accent'">check</mat-icon>
          {{"send-remark.about_map.help.markerplaced"|translate}}
       </p>
        <div class="button-container">
          <button mat-flat-button color="primary" (click)="openDialog()">
            <!--(click)="readyToSend()""-->
            <mat-icon aria-label="map">mode_edit</mat-icon>&nbsp;&nbsp;{{"send-remark.button.fillin"|translate}}...
          </button>
        </div>
        <div class="button-container">
          <a mat-button (click)="unlockPointTouch()" class="back-tip"><mat-icon aria-label="map">arrow_back_ios</mat-icon>&nbsp;{{"send-remark.link.back"|translate}}</a>
        </div>
      </div>
    }
  </div>
}

<!--   desktop-->
@if (!browserSniffer.isTouchDevice) {
  <div>
    <!-- 1 dt  -->
    @if (toolTip.placeMarker) {
      <div>
        <p>
          <span
            style="float:left; background: url(../../../assets/images/remarky.png);width:60px;height:90px;text-align: center;margin-right:20px;">
          </span>
          {{'send-remark.about_map.help.content'|translate}}
        <!-- </p>
        <div class="button-container">
          <button mat-flat-button color="primary" (click)="lockPointTouch()">
            <mat-icon aria-label="map">lock</mat-icon>&nbsp;&nbsp;{{"send-remark.button.placemarker"|translate}}
          </button>
        </div>
        <div class="button-container">
          &nbsp;
        </div> -->
      </div>
    }
    <!-- 2 dt  -->
    @if (toolTip.confirmMarker) {
      <div>
        <p>
          {{'send-remark.about_map.help.confirmmarker'|translate}}
        </p>
        <div class="button-container">
          <button mat-flat-button color="primary" (click)="lockPoint()">
            <mat-icon aria-label="map">lock</mat-icon>&nbsp;&nbsp;{{"send-remark.button.placemarker"|translate}}
          </button>
        </div>
        <div class="button-container">
          &nbsp;
        </div>
      </div>
    }
    <!-- 2 dt  -->
    @if (toolTip.lockMarker) {
      <div>
        <p>
          {{'send-remark.about_map.help.markerplaced'|translate}}
        </p>
        <div class="button-container">
          <button mat-flat-button color="primary" (click)="openDialog()">
            <!--(click)="readyToSend()""-->
            <mat-icon aria-label="map">mode_edit</mat-icon>&nbsp;&nbsp;{{"send-remark.button.fillin"|translate}}
          </button>
        </div>
        <div class="button-container">
          <a mat-button (click)="unlockPoint()" class="back-tip"><mat-icon aria-label="map">arrow_back_ios</mat-icon>{{"send-remark.link.back"|translate}}</a>
        </div>
      </div>
    }
  </div>
}